// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3_962","errors":"Errors_errors__3-MiZ"};